import { Tracker, TrackerTypeWithClientId } from '../../models/Tracker';
import { TrackerSettingExtraFieldConfig } from '~/models/TrackerSettingExtraFields';

export class Adobe implements TrackerTypeWithClientId {
  id: number = Tracker.TYPE_ADOBE;
  label: string = 'Adobe';
  isEnabled: boolean = true;
  hasClientId: boolean = true;
  isRequireClientId = false;

  getClientIdRegexp(): RegExp {
    return /^[a-z0-9]{12}\/[a-z0-9]{13}\/launch-[a-z0-9]{12}$/gi;
  }

  getExtraFields(): TrackerSettingExtraFieldConfig[] {
    return [];
  }
}
